@if (geschaeft) {
  <div class="row">
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement [value]="geschaeft.gbAmt && geschaeft.gbAmt?.name | translateName" label="Grundbuchamt"></cap-kopfdatenelement>
      <cap-kopfdatenelement label="Tagebuchnummer">
        <cap-kompakt-grundbuchgeschaeft [item]="geschaeft"></cap-kompakt-grundbuchgeschaeft>
      </cap-kopfdatenelement>
      <cap-kopfdatenelement [value]="geschaeft.status | translate" label="Tagebuchstatus"></cap-kopfdatenelement>
      <cap-kopfdatenelement [value]="geschaeft.eingangTagebuch | datumZeit" label="Eingang"></cap-kopfdatenelement>
      <cap-kopfdatenelement [value]="geschaeft.zeitpunktRechtsgueltig | datum" label="Abschluss (Rechtsgültigsetzung)">
      </cap-kopfdatenelement>
    </div>
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement [value]="geschaeft.anmelderText" label="AnmelderText"></cap-kopfdatenelement>
      <cap-kopfdatenelement [value]="eGVAnmeldung" label="EGVAnmeldung"></cap-kopfdatenelement>
      <cap-kopfdatenelement [value]="geschaeft.egbtbid" label="EGBTBID"></cap-kopfdatenelement>
      @if (geschaeft?.mRegistraturText?.access === "ALLOWED") {
        <cap-kopfdatenelement [value]="geschaeft.registraturText" label="RegistraturText"></cap-kopfdatenelement>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 col-sm-12">
      <cap-kopfdatenelement [bodyClass]="'col-md-10 col-sm-10'" [labelClass]="'col-md-2 col-sm-2'" label="Beschreibung">
        @if (geschaeft.mBeschreibung.access === "NONE") {
          <span>
            <span class="mb-2">
              <span>{{"gemaessGrundbuch" | translate}}</span>
            </span>
          </span>
        } @else {
          <span>
            {{ geschaeft.beschreibung }}
          </span>
        }
        <ng-template #beschreibung>
          <span>
            {{ geschaeft.beschreibung }}
          </span>
        </ng-template>
      </cap-kopfdatenelement>
    </div>
  </div>
  <cap-stammperson-table [stammpersonen]="geschaeft.anmelder" [tableFullWidth]="false" [title]="'Anmelder'"></cap-stammperson-table>
  @if (!isShowAvReferenzNummern) {
    <div class="row">
      <div class="col-lg-12">
        <cap-beschreibung-table-wrapper [tableFullWidth]="false">
          <span class="cap-table-wrapper-title" style="font-weight: bold">
            <h3 class="mt-md-2 mb-md-2" name="title">{{"Geometergeschaefte" | translate}}</h3>
          </span>
          <ng-container class="cap-table-wrapper-content">
            <cap-geogeschaeft-table [listLoader]="geoGeschaeftLoader" [showTotal]="false" [showZeilenSelect]="false">
            </cap-geogeschaeft-table>
          </ng-container>
        </cap-beschreibung-table-wrapper>
      </div>
    </div>
  }
  @if (isShowAvReferenzNummern) {
    <div>
      <div name="title">
        <h3>{{ "Geometergeschaefte" | translate }}</h3>
      </div>
      @if (avReferenzNrs$ | formatAvReferenznummern | async; as value) {
        <div>
          @if (value && value.length > 0) {
            <div>
              <span>{{ value }}</span>
            </div>
          } @else {
            <div class="mb-2">
              <span>{{"Keine" | translate}}</span>
            </div>
          }
        </div>
      } @else {
        <cap-spinner-small></cap-spinner-small>
      }
    </div>
  }
}

@if (bearbeitetstatus?.mBenutzer.access !== "NONE" && showBearbeitetstatus) {
  <div class="row mt-3">
    <div class="col-md-6 col-sm-12">
      <cap-kopfdatenelement label="MeldungBearbeitet">
        @if (bearbeitetstatus) {
          <span>
            @if (bearbeitetstatus.benutzer) {
              <span> {{ "durch" | translate }} {{ bearbeitetstatus?.benutzer | kompaktBenutzer }} </span>
            }
            @if (!bearbeitetstatus.benutzer) {
              <span> {{ "nichtBearbeitet" | translate }} {{ bearbeitetstatus?.benutzer | kompaktBenutzer }} </span>
            }
          </span>
        }
      </cap-kopfdatenelement>
    </div>
    <div class="col-md-6 col-sm-12">
      @if (
        bearbeitetstatus &&
        hasPermissionStatusBearbeiten &&
        (geschaeft.status === "RECHTSGUELTIG" || geschaeft.status === "RECHTSGUELTIG_AUSGETRAGEN")
      ) {
        <span>
          <button
            (click)="updateBearbeitetStatus()"
            [disabled]="bearbeitenButtondisabled"
            class="btn btn-outline-primary btn-sm"
            type="button">
            @if (bearbeitetstatus.benutzer) {
              <span>
                {{ "MarkiereAlsNichtBearbeitet" | translate }}
              </span>
            }
            @if (!bearbeitetstatus.benutzer) {
              <span>
                {{ "MarkiereAlsBearbeitet" | translate }}
              </span>
            }
          </button>
        </span>
      }
    </div>
  </div>
}

<ng-template #defaultText>{{ "GemaessGrundbuch" | translate }}</ng-template>
